import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import screens from 'screens';
// import ReactGA from 'react-ga';
import Layout from 'screens/shared/layout';
import Loader from 'screens/shared/loader';
import Snackbar from 'screens/shared/snackbar';
import {
  BrowserRouter as Router, Route, Switch, Redirect, withRouter,
} from 'react-router-dom';
import { useNotification } from 'screens/shared/hooks/notifications';
import { ROUTE } from 'constant';
import { enumToArray, explorerObj } from 'utils';
import { featuresToggle } from 'utils/features-toggle';
import { actions, ACTIONS_TYPES } from 'redux/local';

const LayoutRoutes = withRouter(({ history }) => {
  const dispatch = useDispatch();
  useEffect(() => history.listen(() => { // location
    // const { pathname } = location;
    dispatch({
      type: ACTIONS_TYPES.COMMON.BUFFER_CLONE_DATA,
      payload: null,
    });
    // ReactGA.pageview(pathname);
  }));

  return (
    <Layout>
      <Switch>
        {enumToArray(ROUTE.DASHBOARD).map(({ key, path, componentName }) => (
          <Route key={key} path={path} component={explorerObj(screens, componentName)} exact />
        ))}
        <Route path="*" render={() => <Redirect to={ROUTE.DASHBOARD.DATA_CENTERS.path} />} exact />
      </Switch>
    </Layout>
  );
});

export default () => {
  const [errors, successes] = useNotification({ isGetAll: true });

  const resizeScreen = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    actions.common.updateLayoutScreen({ screen: { width, height } });
  };

  useEffect(() => {
    window.addEventListener('resize', resizeScreen);
    // eslint-disable-next-line
  }, []);

  return (
    <Router
      basename={process.env.PUBLIC_URL}
    >
      <Switch>
        {enumToArray(ROUTE.NON_SECURE).map(({ key, path, componentName }) => (
          <Route key={key} path={path} component={explorerObj(screens, componentName)} exact />
        ))}
        <Route path="/(.+)" exact component={LayoutRoutes} />
        <Route path="/" render={() => <Redirect to={ROUTE.NON_SECURE.LOGIN.path} />} exact />
      </Switch>

      <Loader isGlobal />

      {featuresToggle.isExistInConfig('isWhatsnewDialog') && (
        <screens.WhatsNewDialog />
      )}

      <Snackbar
        message={!!errors.length && errors[0].message}
        show={!!errors.length}
        position={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      />

      <Snackbar
        message={!!successes.length && successes[0].message}
        show={!!successes.length}
        position={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        type="success"
      />
    </Router>
  );
};
